module.exports = __webpack_public_path__ + "static/media/white-background-chicago.d31a43df.png";